<template>
  <div class="regPage">
   <el-form :model="regInfo" class="regForm" label-width="100px">
     <el-form-item v-if="!regInfo.userNameStatus"  class="infoInput" label="邮箱地址">
          <span  v-text="regInfo.userName" class="emailAddr"> </span>
          <span class="emailName">@tongji.edu.cn</span>
        </el-form-item>
        <el-form-item v-if="regInfo.userNameStatus" v-for="(itme,index) in regInfo.userNames" class="infoInput" :key="index" label="邮箱地址">
          <span  v-text="itme" class="emailAddr"></span>
          <span class="emailName">@tongji.edu.cn</span>
        </el-form-item>
         
        <div class="infoBtn" >
            <el-button type="primary" @click="blockEmail()">注销</el-button>
            <el-button type="primary" @click="escRegEmail()">取消</el-button>
        </div>

    </el-form>
    <!-- 消息提示栏 -->
    <el-dialog
      :visible.sync="successInfo"
      custom-class="showBox"
      width="467px"
      :close-on-click-modal="boxCloseInfo"
      :close-on-press-escape="boxCloseInfo"
      :show-close="boxCloseInfo"
      center>
      <p class="boxBody">
        <span class="emilName"  v-if="!regInfo.userNameStatus" >{{regInfo.userName}}@tongji.edu.cn </span>
        <span class="emilName"  v-if="regInfo.userNameStatus" >
          <p  v-for="(itme,index) in regInfo.userNames">   <span  v-text="itme"></span>@tongji.edu.cn </p> 
        </span>
        已注销
      </p>
      <span slot="footer" class="dialog-footer">
        <a href="https://mail-mgmt.tongji.edu.cn" class="boxBtn" type="primary">重新注册</a>
        <!-- <a href="https://mail-mgmt-test.tongji.edu.cn" class="boxBtn" type="primary">重新注册</a> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
  const PwdPatrn = (str) => {
    const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
    return reg.exec(str);
}

		
export default {
  name: "blockOfficialForm",
  props: ['userInfo'],
  data() {
    return {
        successInfo:false,
        boxCloseInfo:false,
        userPrincipalName: '',
        errorMsg:"",
        regInfo: {
          xgh:'',
          userName:'',
          userNames:'',
          userNameStatus:false
        },
    };
  },

  methods: {

      //锁定
      blockEmail(){
        let self = this;
        let userNames = "";
        const regEmailStatus = JSON.parse(localStorage.getItem("regEmailStatus"));
        if(!self.regInfo.userNameStatus){
            userNames = self.regInfo.userName
        }else{
            const _userNames = self.regInfo.userNames
            _userNames.forEach(userName => {
              userNames += userName + ",";
            });
            userNames= userNames.substring(0, userNames.length - 1);
        }
        const url = "/email/lockCoremail?xgh=" +self.regInfo.xgh +"&token="+self.md5(regEmailStatus.token)+"&userNames="+userNames
            self.postRequest(url, {}).then(result => {
            if(result.data && result.data.msgStatus==1){
               self.$alert("注销邮箱失败，请重新验证身份", "错误提示", {
                confirmButtonText: "确定",
                type: "error",
                center: true,
                customClass: "errMessage",
                callback: action => {
                  self.$router.push({ name: 'Home'})
                }
              });
            }else if(result.data && result.data.msgStatus==0){
              self.successInfo = true
            }else{
              self.$router.push({ name: 'Home'})
              self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
                confirmButtonText: "确定",
                type: "error",
                center: true,
                customClass: "errMessage",
                callback: action => {
                  self.$router.push({ name: 'Home'})
                }
              });
            }
          
          })
      },
      escRegEmail(){
        const self = this ;
        self.$confirm("取消注销邮箱操作？", "提示", {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          center: true,
          customClass: "errMessage",
          }).then(() => {
          self.$router.push({ name: 'Home'})
        }).catch(() => {
              
        });   
      }

  },
  mounted() {
    const self = this;
    const regEmailStatus = JSON.parse(localStorage.getItem("regEmailStatus"));
    if (regEmailStatus && regEmailStatus.uid && regEmailStatus.token) {
          self.regInfo.xgh = regEmailStatus.uid;
          const userName = regEmailStatus.userName;    
  
          let _userName = new Array();
          if(userName&&userName.indexOf(',')!= -1){
            _userName = userName.split(',')
            self.regInfo.userNameStatus = true
            self.regInfo.userName  = _userName[0]
            self.regInfo.userNames  = _userName
          }else{
             self.regInfo.userNameStatus = false
             self.regInfo.userName  = userName
          }
      
}else{
        self.$router.push({ name: 'Home'})
        self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: action => {
            self.$router.push({ name: 'Home'})
          }
        });
}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.emilName{
  color: #eb5468;
  font-size: 20px;
}
.emailAddr{
  margin-left: 20px;
}
.emailName{
    text-align: center;
  }
.infoInput {
  width: 460px;
  height: 41px;
  margin: 0 auto;
  margin-top: 30px;
}
.tips{
  width: 370px;
    padding: 0;
    line-height: 25px;
    color: #999;
    font-size: 12px;
}
  .infoBtn{
    margin: 0 auto;
    margin-top: 60px;
    text-align: center;
    width: 505px;
  }
    .infoBtn button:nth-of-type(1){
      margin-right: 35px;
    }
  .infoBtn button{
    width: 130px;
  }
 .showBox .boxTitle{
     display: block;
     font-size: 20px;
     color: #778085;
     margin-left: 31px;
  }
  .showBox .boxBody{
     font-size: 16px;
     color: #778085;
     padding: 0 31px;
     word-break:break-all; 
  }
  .showBox .boxBtn{
    display: block;
    width: 395px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    margin-bottom: 30px;
    background: #198bfd;
    color: #fff;
  }
.showBox .boxBtn:hover{
  background: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/page/Coremail/block/form.vue